import React from 'react'

import PropTypes from 'prop-types'

import {
  AttachFile as AttachFileIcon,
  Attachment as AttachmentIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material'
import {
  Avatar,
  Card,
  CardHeader,
  CardMedia,
  IconButton,
} from '@mui/material'

import { useFilestackURL } from '~/src/Lib/Utils'
import Icon from '~/src/UI/Shared/Icon'

const thumbnailable = ['pdf', 'ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'odt', 'odp', 'txt', 'html']

export const FileCardComponent = props => {
  const {
    cardStyle,
    description,
    filename,
    thumbnail,
    mediaStyle,
    title,
    tooltip,
    onDelete,
  } = props
  const filestackURL = useFilestackURL()
  const src = thumbnailable.find(ext => filename.endsWith(ext))
    ? filestackURL(props, ['output=format:png', 'resize=width:320'])
    : null
  const linkProps = { href: filestackURL(props), target: '_blank', rel: 'noopener noreferrer' }
  let cardTitle = tooltip ? title || filename : <a {...linkProps}>{title || filename}</a>
  if (src) {
    cardTitle = undefined
  }

  return (
    <Card style={cardStyle} elevation={0}>
      {thumbnail && src ? null : (
        <CardHeader
          avatar={
            onDelete ? (
              <Avatar>
                <Icon icon={AttachmentIcon} />
              </Avatar>
            ) : null
          }
          action={
            onDelete ? (
              <IconButton
                data-testid="delete-file-attachment-icon"
                onClick={onDelete}
                color="inherit"
                size="large"
              >
                <Icon icon={DeleteIcon} />
              </IconButton>
            ) : null
          }
          title={cardTitle}
          subheader={
            onDelete ? (description || filename) : (
              <>
                <Icon icon={AttachFileIcon} fontSize="small" />
                {filename}
                {tooltip ? <br /> : null}
                {description}
              </>
            )
          }
        />
      )}
      {src ? (
        <CardMedia
          {...linkProps}
          component="a"
          image={src}
          style={mediaStyle}
          title={title || filename}
        />
      ) : null}
    </Card>
  )
}

FileCardComponent.propTypes = {
  cardStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  description: PropTypes.string,
  filename: PropTypes.string.isRequired,
  thumbnail: PropTypes.bool,
  mediaStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  title: PropTypes.string,
  /* eslint-disable react/no-unused-prop-types */
  url: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
  tooltip: PropTypes.bool,
  onDelete: PropTypes.func,
}

FileCardComponent.defaultProps = {
  cardStyle: { minHeight: '33vh', maxHeight: '50vh' },
  description: null,
  thumbnail: false,
  mediaStyle: { paddingTop: `${(11 / 8.5) * 100}%` },
  title: null,
  tooltip: false,
  onDelete: null,
}

export default React.memo(FileCardComponent)
